import { gql } from '@apollo/client';

export const GET_WORKSPACE_NAME = gql`
  query GetWorkspace($id: ID!) {
    workspace: getWorkspace(id: $id) {
      id
      name
    }
  }
`;
